import React from "react";

import { type Impulse, useScoped } from "~/tools/impulse";
import type { ImpulseForm } from "~/tools/impulse-form";

import { useFormFieldDelayedError } from "./_use-form-field-delayed-error";
import { FormMessage } from "./message";

/**
 * The error message displayed when no other FormMessage.variant=error are present in the same FormField.
 */
export const FallbackErrorMessage: React.FC<{
	state: ImpulseForm;
	errorMessageDescendants: Impulse<number>;
}> = ({ state, errorMessageDescendants }) => {
	const delayedErrorMessage = useFormFieldDelayedError(state);

	const hasErrorDescendants = useScoped(
		(scope) => errorMessageDescendants.getValue(scope) > 0,
		[errorMessageDescendants],
	);

	// only show the fallback error message if there are no other error messages in the FormField
	if (hasErrorDescendants || delayedErrorMessage == null) {
		return null;
	}

	return <FormMessage variant="error">{delayedErrorMessage}</FormMessage>;
};
